import Sortable from "sortablejs";
import { patch } from "@rails/request.js";

export default function registerKanban(Alpine) {
  Alpine.data("kanban", () => ({
    sortables: [],

    init() {
      this.$nextTick(() => this.setupSortable());
    },

    destroy() {
      this.sortables.forEach((s) => s.destroy());
      this.sortables = [];
    },

    setupSortable() {
      // Destroy previous instances
      this.sortables.forEach((s) => s.destroy());
      this.sortables = [];

      const columns = this.$root.querySelectorAll("[data-stage-id]");
      columns.forEach((column) => {
        const sortable = Sortable.create(column, {
          group: "kanban",
          animation: 150,
          ghostClass: "opacity-30",
          dragClass: "shadow-2xl",
          handle: "[data-kanban-card]",
          draggable: "[data-kanban-card]",
          onEnd: (evt) => this.onCardMoved(evt)
        });
        this.sortables.push(sortable);
      });
    },

    async onCardMoved(evt) {
      const card = evt.item;
      const opportunityId = card.dataset.opportunityId;
      const newStageId = evt.to.dataset.stageId;
      const expectedStageId = evt.from.dataset.stageId;

      if (!opportunityId || !newStageId) return;

      this.updateColumnCounts(evt.from);
      this.updateColumnCounts(evt.to);
      this.updateColumnTotals(evt.from);
      this.updateColumnTotals(evt.to);

      try {
        const response = await patch(`/opportunities/${opportunityId}/update_stage`, {
          body: JSON.stringify({ pipeline_stage_id: newStageId, expected_stage_id: expectedStageId }),
          contentType: "application/json",
          responseKind: "turbo-stream"
        });

        if (!response.ok) {
          evt.from.insertBefore(card, evt.from.children[evt.oldIndex] || null);
          this.updateColumnCounts(evt.from);
          this.updateColumnCounts(evt.to);
          this.updateColumnTotals(evt.from);
          this.updateColumnTotals(evt.to);
        }
      } catch {
        evt.from.insertBefore(card, evt.from.children[evt.oldIndex] || null);
        this.updateColumnCounts(evt.from);
        this.updateColumnCounts(evt.to);
        this.updateColumnTotals(evt.from);
        this.updateColumnTotals(evt.to);
      }
    },

    updateColumnCounts(column) {
      const countBadge = column.closest("[data-kanban-column]")?.querySelector("[data-count]");
      if (countBadge) {
        const cards = column.querySelectorAll("[data-kanban-card]");
        countBadge.textContent = cards.length;
      }
    },

    updateColumnTotals(column) {
      const totalEl = column.closest("[data-kanban-column]")?.querySelector("[data-column-total]");
      if (totalEl) {
        const cards = column.querySelectorAll("[data-kanban-card]");
        let total = 0;
        cards.forEach((card) => {
          total += parseInt(card.dataset.valueCents || "0", 10);
        });
        totalEl.textContent = this.formatCurrency(total);
      }
    },

    formatCurrency(cents) {
      const amount = cents / 100;
      return new Intl.NumberFormat("nb-NO", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount);
    }
  }));
}
